// Mock content and translations for MICE Travel landing page
// NOTE: This is FRONTEND-ONLY mock data. Backend and dynamic sources (YouTube API, CMS) are not wired. No Spanish version.

export const BRAND = {
  name: "MICE Travel",
  colors: {
    black: "#000000",
    gold: "#D4AF37",
    white: "#FFFFFF",
  },
  logoUrl:
    "https://customer-assets.emergentagent.com/job_97869e2b-5aa9-41c9-926a-a1518d8b9dbf/artifacts/16cqk7xr_LOGO%20MICE%20COMPLETA%20PNG%20PARA%20FUNDO%20PRETO.png",
  whatsapp: "https://wa.me/5531996538559",
  youtubeHeroId: "JueDY7jqMdM", // Updated hero video per request
  youtubeChannelUrl: "https://www.youtube.com/@micetravel",
};

// i18n: Only pt and en
export const I18N = {
  pt: {
    langLabel: "Português",
    nav: {
      about: "Sobre",
      services: "Serviços",
      why: "Diferenciais",
      videos: "Vídeos",
      contact: "Contato",
    },
    hero: {
      title: "Transforme Resultados com Viagens de Incentivo",
      subtitle:
        "A MICE Travel cria experiências corporativas sob medida para motivar equipes e premiar grandes resultados.",
      cta: "Solicite uma Cotação",
    },
    about: {
      title: "Sobre a MICE Travel",
      text:
        "Somos especialistas em viagens de incentivo, missões corporativas e operações MICE de alto padrão. Com presença internacional e rede global de parceiros, operamos grupos com excelência, curadoria de destinos e atendimento premium.",
    },
    services: {
      title: "Serviços",
      items: [
        { key: "incentive", title: "Programas de Viagens de Incentivo", desc: "Experiências sob medida para reconhecer e motivar equipes." },
        { key: "missions", title: "Missões Corporativas", desc: "Conteúdo estratégico, benchmarking e relações institucionais." },
        { key: "dmc", title: "Gestão de Destinos (DMC)", desc: "Operação local completa com parceiros selecionados." },
        { key: "awards", title: "Viagens de Premiação", desc: "Celebrações inesquecíveis com curadoria exclusiva." },
        { key: "custom", title: "Projetos Sob Medida", desc: "Soluções personalizadas de ponta a ponta para sua empresa." },
      ],
    },
    why: {
      title: "Por que escolher a MICE Travel",
      bullets: [
        "Experiências exclusivas e personalizadas",
        "Operação completa e suporte total",
        "Atendimento premium e resultados comprovados",
        "Rede global de parceiros e curadoria dos destinos",
        "Confiança de grandes marcas corporativas",
      ],
    },
    videos: { title: "Vídeos" },
    lead: { title: "Solicite sua Proposta", subtitle: "Preencha o formulário e nossa equipe entrará em contato." },
    finalCta: { title: "Pronto para reconhecer sua equipe com uma experiência inesquecível?", cta: "Solicitar Proposta" },
  },
  en: {
    langLabel: "English",
    nav: {
      about: "About",
      services: "Services",
      why: "Why Us",
      videos: "Videos",
      contact: "Contact",
    },
    hero: {
      title: "Drive Results with Incentive Travel",
      subtitle:
        "MICE Travel designs bespoke corporate experiences to motivate teams and reward outstanding performance.",
      cta: "Request a Quote",
    },
    about: {
      title: "About MICE Travel",
      text:
        "We specialize in incentive travel, corporate missions and premium MICE operations. With international presence and a global partner network, we manage groups with excellence, destination curation and premium service.",
    },
    services: {
      title: "Services",
      items: [
        { key: "incentive", title: "Incentive Travel Programs", desc: "Tailor‑made experiences to recognize and motivate teams." },
        { key: "missions", title: "Corporate Missions", desc: "Strategic content, benchmarking and institutional relations." },
        { key: "dmc", title: "Destination Management (DMC)", desc: "Full local operation with vetted partners." },
        { key: "awards", title: "Awards Trips", desc: "Unforgettable celebrations with exclusive curation." },
        { key: "custom", title: "Bespoke Projects", desc: "End‑to‑end custom solutions for your company." },
      ],
    },
    why: {
      title: "Why choose MICE Travel",
      bullets: [
        "Exclusive, personalized experiences",
        "Complete operation and end‑to‑end support",
        "Premium service and proven results",
        "Global partner network and destination curation",
        "Trusted by major corporate brands",
      ],
    },
    videos: { title: "Videos" },
    lead: { title: "Request Your Proposal", subtitle: "Fill the form and our team will contact you." },
    finalCta: { title: "Ready to reward your team with an unforgettable experience?", cta: "Request Proposal" },
  },
};

// Specific YouTube video IDs requested
export const MOCK_VIDEO_IDS = [
  "ZXR7RVT2dmg", // updated per request
  "Yym4gW8suLE",
  "8WXo3sJ4-No",
];

export const TESTIMONIALS = [];
export const CLIENT_LOGOS = [];
